import http from "../http-common";
import authHeader from "./authHeader";
import { UTILS_API } from "../api";

const downloadFromUrl = (data) => {
  return http.post(`${UTILS_API}/download`, data, { headers: authHeader() });
};

const getMergedDocsToHQ = (data) => {
  return http.post(`${UTILS_API}/merged-to-hq`, data, { headers: authHeader() });
};

const DownloadService = {
  downloadFromUrl,
  getMergedDocsToHQ,
};

export default DownloadService;
